import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { FaPlay } from "react-icons/fa";

const desktopTestimonials = [
  {
    image: "/testimonials1.png",
    large: true,
    youtube: "https://www.youtube.com/embed/KJpPDAuTafQ",
  },
  {
    image: "/testmonials2.png",
    youtube: "https://www.youtube.com/embed/Z6nobKFArPw",
  },
  {
    image: "/testmonials3.png",
    youtube: "https://www.youtube.com/embed/E6UZB7jQIyo",
  },
  {
    image: "/testimonials4.png",
    youtube: "https://www.youtube.com/embed/olXTBNIU_eE",
  },
];

const mobileTestimonials = [
  {
    image: "/mobile-testimonial1.png",
    youtube: "https://www.youtube.com/embed/KJpPDAuTafQ",
  },
  {
    image: "/mobile-testimonial2.png",
    youtube: "https://www.youtube.com/embed/Z6nobKFArPw",
  },
  {
    image: "/mobile-testimonial3.png",
    youtube: "https://www.youtube.com/embed/E6UZB7jQIyo",
  },
  {
    image: "/mobile-testimonial4.png",
    youtube: "https://www.youtube.com/embed/olXTBNIU_eE",
  },
];

const VoicesUnlocked = () => {
  const [show, setShow] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");

  const openVideo = (youtube) => {
    setSelectedVideo(youtube);
    setShow(true);
  };

  const closeVideo = () => {
    setShow(false);
    setSelectedVideo("");
  };

  return (
    <section className="voices-section">
      <Container>
        {/* Heading */}
        <div className="voices-heading px-3">
          <h1>Voices Unlocked</h1>

          <p>
            Real Stories, Shared By Those Who Now Call This Home.
          </p>
        </div>

        {/* Desktop */}
        <Row className="g-4 desktop-voices">
          <Col lg={4}>
            <VoiceCard
              image={desktopTestimonials[0].image}
              youtube={desktopTestimonials[0].youtube}
              large
              openVideo={openVideo}
            />
          </Col>

          <Col lg={8}>
            <Row className="g-4">
              <Col lg={4}>
                <VoiceCard
                  image={desktopTestimonials[1].image}
                  youtube={desktopTestimonials[1].youtube}
                  openVideo={openVideo}
                />
              </Col>

              <Col lg={4}>
                <VoiceCard
                  image={desktopTestimonials[2].image}
                  youtube={desktopTestimonials[2].youtube}
                  openVideo={openVideo}
                />
              </Col>

              <Col lg={4}>
                <VoiceCard
                  image={desktopTestimonials[3].image}
                  youtube={desktopTestimonials[3].youtube}
                  openVideo={openVideo}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Mobile */}
        <Row className="g-4 mobile-voices">
          {mobileTestimonials.map((item, index) => (
            <Col xs={6} key={index}>
              <VoiceCard
                image={item.image}
                youtube={item.youtube}
                mobile
                openVideo={openVideo}
              />
            </Col>
          ))}
        </Row>
      </Container>

      {/* Modal */}
      <Modal
        show={show}
        onHide={closeVideo}
        centered
        size="lg"
        backdropClassName="contact-modal-backdrop"
      >
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            {selectedVideo && (
              <iframe
                src={`${selectedVideo}?autoplay=1`}
                title="YouTube video"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

const VoiceCard = ({
  image,
  youtube,
  large,
  mobile,
  openVideo,
}) => {
  return (
    <div
      className={`voice-card 
      ${large ? "large-card" : ""} 
      ${mobile ? "mobile-card" : ""}`}
      onClick={() => openVideo(youtube)}
    >
      <img src={image} alt="" />

      <button className="play-btn">
        <FaPlay />
      </button>
    </div>
  );
};

export default VoicesUnlocked;